import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'

//import "bootstrap/dist/css/bootstrap.min.css"
//import "bootstrap"
import i18n from './i18n'
import router from './router'
// Register it globally
//import { ValidationProvider} from 'vee-validate';
var countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/sk.json"));
countries.registerLocale(require("i18n-iso-countries/langs/cs.json"));

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 500) {
      const t = i18n.global.t;
      const tel = t('contact.tel');
      const email = t('contact.email');
      alert(`Ospravedlňujeme sa, nastala chyba na serveri. Prosím, kontaktujte nás na telefónnom čísle ${tel} alebo e‑mailom na ${email}.`);
    }
    return Promise.reject(error);
  }
);

var app = createApp(App).use(router);
app.config.globalProperties.$product = 'short_eu_day'
//app.use(vue3_accessible_accordions);
//app.component('ValidationProvider', ValidationProvider);
//app.use(CookieConsent, consentOptions)
app.use(i18n).mount('#app')
